'use client'

import { useEffect } from 'react'
import Link from 'next/link'
import { AlertTriangle, Home, RefreshCw } from 'lucide-react'

import { Button } from '@/components/ui/button'
import {
  Card,
  CardContent,
  CardDescription,
  CardFooter,
  CardHeader,
  CardTitle,
} from '@/components/ui/card'
import { logClientError } from '@/lib/clientLogger'

export default function Error({
  error,
  reset,
}: {
  error: Error & { digest?: string }
  reset: () => void
}) {
  useEffect(() => {
    logClientError(error, {
      type: 'react-error-boundary',
      digest: error.digest,
    })
  }, [error])

  return (
    <main className="flex min-h-dvh items-center justify-center bg-background px-4 py-10 text-foreground sm:px-6">
      <Card className="w-full max-w-lg overflow-hidden border-border/70 shadow-lg">
        <CardHeader className="items-center space-y-4 text-center">
          <div className="rounded-full bg-destructive/10 p-4 text-destructive">
            <AlertTriangle className="h-9 w-9" aria-hidden="true" />
          </div>

          <div className="space-y-2">
            <CardTitle className="text-2xl sm:text-3xl">
              Что-то пошло не так
            </CardTitle>
            <CardDescription className="text-base leading-6">
              Мы уже получили информацию об ошибке. Попробуйте обновить страницу
              или вернитесь на главную.
            </CardDescription>
          </div>
        </CardHeader>

        {error.digest ? (
          <CardContent className="pt-0">
            <div className="rounded-lg border bg-muted/50 px-4 py-3 text-center text-sm text-muted-foreground">
              Код ошибки для поддержки:{' '}
              <span className="font-mono text-foreground">{error.digest}</span>
            </div>
          </CardContent>
        ) : null}

        <CardFooter className="flex-col-reverse gap-3 sm:flex-row sm:justify-center">
          <Button variant="outline" className="w-full sm:w-auto" asChild>
            <Link href="/">
              <Home className="h-4 w-4" aria-hidden="true" />
              На главную
            </Link>
          </Button>
          <Button className="w-full sm:w-auto" onClick={() => reset()}>
            <RefreshCw className="h-4 w-4" aria-hidden="true" />
            Попробовать снова
          </Button>
        </CardFooter>
      </Card>
    </main>
  )
}